import * as React from "react";

// internal
import classNames from "classnames";

// styles

///////////////
// Component //
///////////////

type CalloutTipProps = {
  tipPosition?: "top" | "right" | "bottom" | "left";
  leftAligned?: boolean;
  children: React.ReactNode;
};

export const CalloutTip = ({ tipPosition = "bottom", leftAligned, children }: CalloutTipProps) => {
  const renderTip = () => {
    let containerStyle: React.CSSProperties;
    let pathStyle: React.CSSProperties;

    switch (tipPosition) {
      case "top":
        containerStyle = {
          bottom: "calc(100% - 5px)",
        };
        pathStyle = {};
        break;
      case "left":
        containerStyle = {
          top: 30,
          transform: "translateX(-100%)",
        };
        pathStyle = {
          transform: "rotate(-90deg)",
        };
        break;
      case "right":
        containerStyle = {
          top: 30,
          right: 0,
          transform: "translateX(100%)",
        };
        pathStyle = {
          transform: "rotate(90deg)",
        };
        break;
      case "bottom":
      default:
        containerStyle = {
          top: "calc(100% - 5px)",
        };
        pathStyle = {
          transform: "scaleY(-1) translateY(-100%)",
        };
        break;
    }

    return (
      <div
        style={containerStyle}
        className={classNames("cw-absolute cw-flex cw-w-full", {
          "cw-justify-center": !leftAligned,
          "cw-ml-8": leftAligned,
        })}
      >
        <svg width="20" height="16" viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg">
          <path
            className="cw-fill-[#003F2E]"
            style={pathStyle}
            d="M7.2311 1.68911L0.723854 13.0028C-0.043029 14.3362 0.919403 16 2.45754 16H17.0988C18.7284 16 19.674 14.1556 18.7227 12.8325L10.5887 1.51878C9.74013 0.338539 7.95583 0.429063 7.2311 1.68911Z"
            fill="currentColor"
          />
        </svg>
      </div>
    );
  };
  return (
    <div className="cw-relative cw-rounded-2xl cw-shadow-md cw-bg-[#003F2E]">
      {renderTip()}
      <div className="cw-relative cw-w-full cw-h-full cw-rounded-2xl cw-p-4 cw-caption cw-text-onEmphasis">
        {children}
      </div>
    </div>
  );
};
